module.exports = __webpack_public_path__ + "34648d6e64465418c9c0f4e3ecff0fb7.svg";